import cn from 'classnames';
import { useRef } from 'react';
import useWaveform, {
  GetWaveformCanvasSize,
  UseWaveformProps,
} from 'components/Player/useWaveform';
import sampleWaveformData from 'resources/sample.min.json';
import { random } from 'utils/math';
import Artwork, { ArtworkProps } from './Artwork';
import styles from './Audiogram.module.scss';

export interface AudiogramProps
  extends Pick<ArtworkProps, 'aspectRatio' | 'aspectRatioBasis' | 'resize'>,
    Pick<UseWaveformProps, 'getCanvasSize'> {
  className?: string;
  children?: React.ReactNode;
  waveformClassName?: string;
  waveformColor?: string;
  style?: React.CSSProperties;
}

const defaultGetCanvasSize: GetWaveformCanvasSize = ({
  height: playerHeight,
  width: playerWidth,
}) => ({
  height: playerHeight * 0.16,
  width: playerWidth,
});

const Audiogram: React.FC<AudiogramProps> = ({
  aspectRatio = 1,
  aspectRatioBasis,
  className,
  getCanvasSize = defaultGetCanvasSize,
  resize = 'fill',
  children,
  waveformClassName,
  waveformColor,
  style,
}) => {
  const sampleFrameIndex = useRef(random(sampleWaveformData.length));

  const { canvasSize, setCanvas } = useWaveform({
    getCanvasSize,
    sampleFrame: sampleWaveformData[sampleFrameIndex.current],
    color: waveformColor,
  });

  return (
    <div className={className} style={style}>
      <Artwork {...{ aspectRatio, aspectRatioBasis, resize }} />
      <canvas
        {...canvasSize}
        className={cn(styles.waveform, waveformClassName)}
        ref={setCanvas}
      />
      {children}
    </div>
  );
};

export default Audiogram;
